import { createAction, createSlice } from '@reduxjs/toolkit';

import { resetStateAction, userInstrumentsSlice } from '!core/redux';
import { setFavInstr } from '»utils/setFavInstr';

const initialState = {
  data: [],
  extra: {},
  selectedTitle: {},
};

const logoutSuccessAction = createAction('logoutSlice/logoutSuccess');

const clearState = () => ({ ...initialState });

export const walletSlice = createSlice({
  name: 'walletSlice',
  initialState,
  reducers: {
    walletRequest: (state) => {
      state.isLoading = true;
    },
    walletSuccess: (state, action) => {
      if (action.payload.length > 0) {
        const selectedTitleExists = state.data.some(
          (currentTitle) =>
            currentTitle.symbol === state.selectedTitle.symbol &&
            currentTitle.exchange === state.selectedTitle.exchange &&
            currentTitle.securityType === state.selectedTitle.securityType,
        );

        if (state.data.length === 0 || !selectedTitleExists)
          state.selectedTitle = {
            ...action.payload[0],
          };
      } else {
        state.selectedTitle = {};
      }

      state.data = action.payload;
      state.isLoading = false;
    },
    walletFailure: (state) => {
      state.isLoading = false;
    },
    setSelectedTitle: (state, action) => {
      const { symbol, exchange, securityType } = action.payload;

      const title = state.data.find(
        (currentTitle) =>
          currentTitle.symbol === symbol &&
          currentTitle.exchange === exchange &&
          currentTitle.securityType === securityType,
      );

      state.selectedTitle = title;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logoutSuccessAction, clearState)
      .addCase(resetStateAction, clearState)
      .addCase(
        userInstrumentsSlice.actions.setFavInstrumentSuccess,
        (state, action) => {
          const { option, instrument, symbol, exchange, securityType } =
            action.payload;

          const { updatedData } = setFavInstr({
            option,
            instrument,
            symbol,
            exchange,
            securityType,
            data: state.data,
            updateSelectedTitle: false,
          });

          state.data = updatedData;
        },
      );
  },
});
